export default "__VITE_PUBLIC_ASSET__580e9337__"